/***************
 * TODO: The provider props here is just basic change handling, very similar to other provider props.
 * Should think about how some of this can be made common.
 ****************/
import * as oPath from '../../../../Lib/Object/Path/Immutable';

// Only props you want to override on the consumer need to be returned.
export const getWorksheetGridQueryProviderProps = (consumerProps, providerData) => {
  const { name, onChange: consumerOnChange, value: consumerValue, copyTo } = consumerProps;
  const { setValue, submit, data } = providerData;

  let providerProps = { hasInjectedProps: true };

  // Set value
  if (name && consumerValue === undefined) {
    let value = oPath.get(data, name);
    if (value === undefined) value = null; // Remove undefined
    providerProps.value = value;
  }

  // Set onChange
  if (name && !consumerOnChange) {
    const onChange = ({ data: { value, submitValues = false } = {} }) => {
      if (name !== undefined && value !== undefined) {
        setValue({ name, value, sync: submitValues });
        copyTo?.forEach((d) => setValue({ name: d, value, sync: submitValues }));
      } else if (submitValues) submit();
    };

    providerProps.onChange = onChange;
  }

  return providerProps;
};
